/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, cx, jsx } from '@atlaskit/css';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Flex } from '@atlaskit/primitives/compiled';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
import { token } from '@atlaskit/tokens';
import { getFrontendExperiment } from '@atlassian/search-experiment/frontend';

import { useAIAnswerContext } from './ai-answer-context';
import { ReadingAidsOptions } from './reading-aids-options/reading-aids-options';

const DEFINITION_DIALOG_TITLE_ID = 'definition-dialog-title';

const styles = cssMap({
	titleWrapper: {
		justifyContent: 'space-between',
		alignItems: 'center',
		marginTop: token('space.250'),
		marginRight: token('space.300'),
		marginLeft: token('space.300'),
	},
	titleWrapperUpdateStyles: {
		marginTop: token('space.150'),
		marginRight: token('space.200'),
		marginLeft: token('space.200'),
	},
	definitionTitle: {
		font: token('font.heading.small'),
		color: token('color.text'),
	},
});

export const AIAnswerTitle: () => JSX.Element = () => {
	const { commonAttributes, baseQuery } = useAIAnswerContext();
	const { query } = commonAttributes;

	const { serveExperiment: serveDefinitionsUXExp } = getFrontendExperiment({
		abTestId: 'kd_definitions_ux_uplift_exp',
	});
	const serveDefinitionUXUpdates = serveDefinitionsUXExp && fg('kd_definitions_ux_uplift_exp_gate');
	const isA11yDefinitionDialogRoleFixEnabled = expValEquals(
		'a11y-fixes-week1-june-2026',
		'isEnabled',
		true,
	);

	return (
		<Flex
			xcss={cx(styles.titleWrapper, serveDefinitionUXUpdates && styles.titleWrapperUpdateStyles)}
		>
			<Box
				xcss={styles.definitionTitle}
				testId="definition-answer-card-title"
				as="h2"
				id={isA11yDefinitionDialogRoleFixEnabled ? DEFINITION_DIALOG_TITLE_ID : undefined}
			>
				{baseQuery ? baseQuery : query}
			</Box>
			<ReadingAidsOptions />
		</Flex>
	);
};
